export default "__VITE_PUBLIC_ASSET__c66ef563__"